<template>
	<baseContent navIndex="999">
		<div class="bg-lin-ef">
			<div class="width-1280 plr-20">
				<el-row :gutter="20">
					<el-col :span="18">
						<personal-left></personal-left>
					</el-col>
					<el-col :span="6">
						<div class="personal-msg bg-fff">
							<div class="personal-other">
								<div class="flex align-c">
									<el-image class="msg-headr"
										:src="require('@/assets/images/nav/tx-n.png')"></el-image>
									<div>
										<div class="col-333 bold f16 lin-22">林子豪</div>
										<div class="mt-10 col-666 f12 lin-16">
											30岁&nbsp;&nbsp;|&nbsp;&nbsp;6年以上&nbsp;&nbsp;|&nbsp;&nbsp;本科
										</div>
									</div>
								</div>
								<div class="mt-20 flex align-c">
									<div class="flex align-c justify-c other-label">
										<div class="f14 lin-20 col-333">离职-随时到岗</div>
										<el-image class="other-dowm"
											:src="require('@/assets/images/personal/drop-down@2x.png')"></el-image>
									</div>
									<div class="other-edit flex align-c justify-c">
										<el-image class="edit-dowm"
											:src="require('@/assets/images/personal/edit@2x.png')"></el-image>
										<div class="f14 lin-20 col-333">编辑</div>
									</div>
								</div>
							</div>
							<div class="personal-interview flex align-c">
								<div class="interview-w5 text-c">
									<div class="col-333 f18 lin-25">28</div>
									<div class="col-666 f14 lin-20">已投递</div>
								</div>
								<div class="interview-w5 text-c">
									<div class="col-333 f18 lin-25">0</div>
									<div class="col-666 f14 lin-20">面试</div>
								</div>
							</div>
						</div>
						<div class="accessory bg-fff">
							<div class="f6f-head flex align-c f16 lin-22 bold col-333">
								附件管理
							</div>
							<div class="accessory-body">
								<div class="accessory-item flex align-c justify-sb" v-for="(item,index) in accessoryList" :key="index">
									<div class="f16 lin-22 col-333">{{item.name}}</div>
									<el-image class="accessory-del"
										:src="require('@/assets/images/personal/delete@2x.png')"></el-image>
								</div>
								<div class="accessory-btn">
									<div class="flex align-c justify-c accessory-btn1 col-fff f16 lin-22">上传简历/作品集</div>
								</div>
							</div>
						</div>
						<div class="bg-fff attention">
							<div class="flex align-c attention-tabs">
								<div class="attention-tabs-item flex align-c justify-c bold f16 lin-22" v-for="(item,index) in attentionTabsList" :key="index" @click="attentionChange(item,index)" :class="attentionTabsIndex == index ? 'col-169' : 'col-333'">
									{{item.name}}
									<div class="tabs-ia" v-if="attentionTabsIndex == index"></div>
								</div>
							</div>
							<div class="attention-list">
								<div class="attention-item" v-for="(item,index) in attentionList" :key="index">
									<div class="flex align-c justify-sb">
										<div class="flex align-c">
											<el-image class="attention-headr"
												:src="require('@/assets/images/nav/tx-n.png')"></el-image>
											<div class="f14 lin-20 bold col-333">许{{index%2==0?'女士':'先生'}}·HR</div>
										</div>
										<div class="f12 col-666 lin-16">先行网络</div>
									</div>
									<div class="flex align-c justify-sb mt-8">
										<div class="f12 lin-16 col-666">产品经理</div>
										<div class="f14 lin-20 col-fe5 bold">{{index+1}}-20K·14薪</div>
									</div>
								</div>
							</div>
							<div class="flex align-c justify-c attention-more">
								<div class="f14 lin-20 col-666">查看详情</div>
								<el-image class="attention-down"
									:src="require('@/assets/images/course/drop-down@2x.png')"></el-image>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
	</baseContent>
</template>

<script>
	import baseContent from '@/components/base-content.vue'
	import personalLeft from './components/personal-left.vue'
	export default{
		components:{ baseContent,personalLeft },
		data(){
			return{
				accessoryList:[
					{name:'林子豪-产品经理.pdf'},
					{name:'产品经理作品集.pdf'}
				],
				attentionTabsList:[
					{name:'看过我'},
					{name:'对我感兴趣'}
				],
				attentionTabsIndex:0,
				attentionList:[
					{},{},{},{},{}
				],
			}
		},
		mounted() {
			
		},
		methods:{
			attentionChange(item,index){
				this.attentionTabsIndex = index
			}
		}
	}
</script>

<style>
	.plr-20{
		padding: 20px 20px 60px 20px;
	}
	.personal-msg{
		border-radius: 12px;
		overflow: hidden;
		height: 206px;
	}
	.personal-interview{
		height: 62px;
		background: #F6FBFA;
		padding-top: 6px;
	}
	.interview-w5{
		width: 50%;
	}
	.f18{
		font-size: 18px;
	}
	.f14{
		font-size: 14px;
	}
	.f16{
		font-size: 16px;
	}
	.f12{
		font-size: 12px;
	}
	.lin-25{
		line-height: 25px;
	}
	.lin-20{
		line-height: 20px;
	}
	.lin-22{
		line-height: 22px;
	}
	.lin-16{
		line-height: 16px;
	}
	.personal-other{
		height: 144px;
		padding: 24px 20px 0 20px;
	}
	.msg-headr{
		width: 48px;
		height: 48px;
		margin-right: 12px;
		border-radius: 50%;
	}
	.mt-10{
		margin-top: 10px;
	}
	.other-dowm{
		width: 8px;
		height: 6px;
		margin-left: 8px;
	}
	.other-label{
		padding: 0 14px;
		height: 36px;
		border-radius: 8px;
		border: 1px solid #D4D5D6;
	}
	.edit-dowm{
		width: 16px;
		height: 16px;
		margin-right: 8px;
	}
	.other-edit{
		margin-left: 18px;
		padding: 0 14px;
		height: 36px;
		border-radius: 8px;
		border: 1px solid #D4D5D6;
	}
	.accessory{
		margin-top: 18px;
		border-radius: 12px;
		overflow: hidden;
	}
	.f6f-head{
		height: 48px;
		background: #F6FBFA;
		padding: 0 20px;
	}
	.accessory-body{
		padding: 0 20px 18px 20px;
	}
	.accessory-item{
		margin-top: 16px;
	}
	.accessory-del{
		width: 16px;
		height: 16px;
	}
	.accessory-btn{
		margin-top: 18px;
		padding-top: 16px;
		border-top: 1px solid #E4E4E4;	
	}
	.accessory-btn1{
		height: 38px;
		background: #169BD5;
		border-radius: 10px;
	}
	.attention{
		border-radius: 12px;
		overflow: hidden;
		margin-top: 18px;
	}
	.attention-tabs{
		height: 48px;
		background: #F6FBFA;
	}
	.attention-tabs-item{
		width: 50%;
		height: 48px;
		position: relative;
		cursor: pointer;
	}
	.tabs-ia{
		position: absolute;
		width: 24px;
		height: 3px;
		background: #169BD5;
		border-radius: 3px;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}
	.attention-list{
		padding: 20px 14px 0 14px;
	}
	.attention-item{
		height: 50px;
		margin-bottom: 16px;
	}
	.attention-headr{
		width: 26px;
		height: 26px;
		margin-right: 8px;
	}
	.mt-8{
		margin-top: 8px;
	}
	.col-fe5{
		color: #FE574A;
	}
	.attention-more{
		height: 52px;
	}
	.attention-down{
		width: 6px;
		height: 8px;
		margin-left: 8px;
	}
</style>